module.exports = __webpack_public_path__ + "f0ecfaa149a72cf730d66b48f2474545.glb";